// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3Neu1","range":"MonthRangeSwitch_range__2ylex","disabled":"MonthRangeSwitch_disabled__3lpmi"};